var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-image-gallery-wrapper',{attrs:{"images":[_vm.image],"labelled-by":""}},[_c('modal-image-gallery-item',[_c('adaptive-image-new',{attrs:{"image":_vm.image}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }